module.exports = __webpack_public_path__ + "static/media/pt.4a45cebb.webp";